<template>
  <!--
    Extracted from SidebarMenu so a nav item can render its icon in more than one place —
    a plain link and a collapsible group header need the same glyph, and duplicating ~200
    lines of inline SVG to get it is how the two drift apart.

    Matched on `title` exactly as before; this is a move, not a rewrite.
  -->
      <svg
        v-if="title === 'Employee Benefits'"
        class="nav-icon"
        width="20"
        height="24"
        viewBox="0 0 20 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.82406 9.64361C2.82406 7.50389 4.55851 5.76944 6.69823 5.76944C8.83795 5.76944 10.5724 7.50389 10.5724 9.64361C10.5724 11.7833 8.83795 13.5178 6.69823 13.5178C4.55851 13.5178 2.82406 11.7833 2.82406 9.64361ZM8.34211 13.782H5.05456C2.3195 13.782 0.0942383 16.0072 0.0942383 18.7419V22.7634L0.104538 22.8261L0.382112 22.9127C2.99183 23.7279 5.25991 24 7.12642 24C10.772 24 12.8848 22.9605 13.0156 22.8944L13.2749 22.7628L13.3022 22.7631V18.7419C13.3022 16.0072 11.077 13.782 8.34211 13.782ZM13.3022 7.74821C15.4418 7.74821 17.1763 6.01376 17.1763 3.87404C17.1763 1.73445 15.4418 0 13.3022 0C11.1626 0 9.42801 1.73445 9.42801 3.87404C9.42806 6.01376 11.1626 7.74821 13.3022 7.74821ZM14.9459 8.01234H11.6584C11.58 8.01234 11.5036 8.02059 11.4262 8.02434C11.7235 8.64823 11.895 9.34347 11.895 10.0797C11.895 11.4383 11.3251 12.6636 10.4145 13.5376C12.5453 14.1714 14.1741 15.981 14.5448 18.211C17.6871 18.0737 19.4986 17.1858 19.6191 17.1249L19.8783 16.9933L19.9056 16.9938V12.9726C19.9062 10.2377 17.6809 8.01234 14.9459 8.01234Z"
          fill="currentColor"
        />
      </svg>

      <svg
        v-if="title === 'Overview' || title === 'Finish Setup'"
        class="nav-icon"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 10H8V0H0V10ZM0 18H8V12H0V18ZM10 18H18V8H10V18ZM10 0V6H18V0H10Z"
          fill="currentColor"
        />
      </svg>
      <svg
        v-if="title === 'Private Raise'"
        class="nav-icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_4245_7375)">
          <path
            d="M19.0207 11.9236C21.7286 11.9236 23.9238 10.6765 23.9238 9.1382C23.9238 7.59985 21.7286 6.35278 19.0207 6.35278C16.3128 6.35278 14.1177 7.59985 14.1177 9.1382C14.1177 10.6765 16.3128 11.9236 19.0207 11.9236Z"
            fill="currentColor"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.0942 13.526C15.5874 13.526 14.1912 12.0564 14.1912 11.2051V14.8517C14.1912 16.3905 16.3865 17.6357 19.0942 17.6357C21.8048 17.6357 24.0001 16.3905 24.0001 14.8517V11.2926C24.0001 12.1453 22.6025 13.526 19.0942 13.526Z"
            fill="currentColor"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.0942 19.1603C15.9573 19.1603 14.1912 17.7471 14.1912 16.8958V20.5085C14.1912 22.0473 16.3865 23.2939 19.0942 23.2939C21.8048 23.2939 24.0001 22.0473 24.0001 20.5085V16.8521C24.0001 17.7033 22.2326 19.1603 19.0942 19.1603Z"
            fill="currentColor"
          />
          <path
            d="M6.96998 6.27663C10.0396 6.27663 12.5281 5.02956 12.5281 3.49122C12.5281 1.95288 10.0396 0.705811 6.96998 0.705811C3.90032 0.705811 1.41187 1.95288 1.41187 3.49122C1.41187 5.02956 3.90032 6.27663 6.96998 6.27663Z"
            fill="currentColor"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.1465 7.87905C3.17238 7.87905 1.58838 6.4094 1.58838 5.55811V9.20469C1.58838 10.7435 4.07732 11.9887 7.1465 11.9887C10.2185 11.9887 12.706 10.7435 12.706 9.20469V5.64563C12.706 6.49834 11.1206 7.87905 7.1465 7.87905Z"
            fill="currentColor"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.1465 13.5133C3.59026 13.5133 1.58838 12.1001 1.58838 11.2488V14.8615C1.58838 16.4004 4.07732 17.647 7.1465 17.647C10.2185 17.647 12.706 16.4004 12.706 14.8615V11.2051C12.706 12.0564 10.7013 13.5133 7.1465 13.5133Z"
            fill="currentColor"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.1465 19.1603C3.59026 19.1603 1.58838 17.7471 1.58838 16.8958V20.5085C1.58838 22.0473 4.07732 23.2939 7.1465 23.2939C10.2185 23.2939 12.706 22.0473 12.706 20.5085V16.8521C12.706 17.7033 10.7013 19.1603 7.1465 19.1603Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_4245_7375">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>

      <svg
        v-if="title === 'Wallet'"
        class="nav-icon"
        width="20"
        height="18"
        viewBox="0 0 20 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 6H19C19.2652 6 19.5196 6.10536 19.7071 6.29289C19.8946 6.48043 20 6.73478 20 7V17C20 17.2652 19.8946 17.5196 19.7071 17.7071C19.5196 17.8946 19.2652 18 19 18H1C0.734784 18 0.48043 17.8946 0.292893 17.7071C0.105357 17.5196 0 17.2652 0 17V6ZM1 0H16V4H0V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0ZM13 11V13H16V11H13Z"
          fill="currentColor"
        />
      </svg>

      <svg
        v-if="title === 'Teams'"
        class="nav-icon"
        width="22"
        height="21"
        viewBox="0 0 22 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.79822 0C8.33953 0 6.94058 0.579463 5.90913 1.61091C4.87768 2.64236 4.29822 4.04131 4.29822 5.5C4.29822 6.95869 4.87768 8.35764 5.90913 9.38909C6.94058 10.4205 8.33953 11 9.79822 11C11.2569 11 12.6559 10.4205 13.6873 9.38909C14.7188 8.35764 15.2982 6.95869 15.2982 5.5C15.2982 4.04131 14.7188 2.64236 13.6873 1.61091C12.6559 0.579463 11.2569 0 9.79822 0ZM21.2982 17H17.2982V21H15.2982V17H11.2982V15H15.2982V11H17.2982V15H21.2982V17ZM11.1742 12C10.2803 13.1415 9.79575 14.5502 9.79822 16C9.79822 17.509 10.3122 18.897 11.1742 20H0.298218V18C0.298218 16.4087 0.930359 14.8826 2.05558 13.7574C3.1808 12.6321 4.70692 12 6.29822 12H11.1742Z"
          fill="currentColor"
        />
      </svg>

      <svg
        v-if="title === 'Credit Provider'"
        class="nav-icon"
        width="20"
        height="15"
        viewBox="0 0 20 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.00200009 5H19.998C19.986 2.825 19.89 1.647 19.121 0.879C18.243 1.78814e-07 16.828 0 14 0H6C3.172 0 1.757 1.78814e-07 0.879 0.879C0.11 1.647 0.0140001 2.825 0.00200009 5ZM20 7H0V9C0 11.828 -5.96046e-08 13.243 0.879 14.121C1.757 15 3.172 15 6 15H14C16.828 15 18.243 15 19.121 14.121C20 13.243 20 11.828 20 9V7ZM5 10C4.73478 10 4.48043 10.1054 4.29289 10.2929C4.10536 10.4804 4 10.7348 4 11C4 11.2652 4.10536 11.5196 4.29289 11.7071C4.48043 11.8946 4.73478 12 5 12H5.01C5.27522 12 5.52957 11.8946 5.71711 11.7071C5.90464 11.5196 6.01 11.2652 6.01 11C6.01 10.7348 5.90464 10.4804 5.71711 10.2929C5.52957 10.1054 5.27522 10 5.01 10H5Z"
          fill="currentColor"
        />
      </svg>

      <svg
        v-if="title === 'Public Raise'"
        class="nav-icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 3V19H21V21H3V3H5ZM19.94 5.94L22.06 8.06L16 14.122L13 11.122L9.06 15.062L6.94 12.94L13 6.88L16 9.88L19.94 5.94Z"
          fill="currentColor"
        />
      </svg>

      <svg
        v-if="title === 'Treasury'"
        class="nav-icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.89701 17.86L7.80701 13.95L10.636 16.778L15.207 12.208L17 14V9H12L13.793 10.793L10.636 13.95L7.80801 11.121L2.86201 16.067C2.29194 14.787 1.99821 13.4012 2.00001 12C2.00001 6.477 6.47701 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C10.418 22.001 8.85839 21.6262 7.44962 20.9065C6.04084 20.1867 4.82321 19.1425 3.89701 17.86Z"
          fill="currentColor"
        />
      </svg>
      <svg
        v-if="title === 'API Integration' || title === 'GetEquity API'"
        class="nav-icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_1346_1288)">
          <path
            d="M1.01433 13.813L2.58721 13.8228C2.82241 15.0331 3.2879 16.2091 3.99349 17.2772L2.87631 18.3846C2.47451 18.7815 2.47451 19.4234 2.86651 19.8252L4.07189 21.0453C4.46879 21.4471 5.11068 21.4471 5.51248 21.0551L6.62966 19.9477C7.68805 20.6631 8.85914 21.1482 10.0694 21.3932L10.0596 22.9661C10.0547 23.5296 10.5104 23.9853 11.0739 23.9902L12.7889 24C13.3524 24.0049 13.8081 23.5492 13.813 22.9857L13.8228 21.4128C15.0331 21.1776 16.2091 20.7121 17.2772 20.0065L18.3846 21.1237C18.7815 21.5255 19.4234 21.5255 19.8252 21.1335L21.0453 19.9281C21.4471 19.5312 21.4471 18.8893 21.0551 18.4875L19.9477 17.3703C20.6631 16.3119 21.1482 15.1409 21.3932 13.9306L22.9661 13.9404C23.5296 13.9453 23.9853 13.4896 23.9902 12.9261L24 11.2111C24.0049 10.6476 23.5492 10.1919 22.9857 10.187L21.4128 10.1772C21.1776 8.96694 20.7121 7.79095 20.0065 6.72276L21.1237 5.61537C21.5255 5.21848 21.5255 4.57659 21.1335 4.17479L19.9281 2.9547C19.5312 2.55291 18.8893 2.55291 18.4875 2.9449L17.3703 4.05229C16.3119 3.3369 15.1409 2.85181 13.9306 2.60681L13.9404 1.03393C13.9453 0.470434 13.4896 0.014739 12.9261 0.00983903L11.2111 3.91485e-05C10.6476 -0.00486079 10.1919 0.450834 10.187 1.01433L10.1723 2.58721C8.95714 2.82241 7.78115 3.2879 6.71786 3.99349L5.61047 2.87631C5.21358 2.47451 4.57169 2.47451 4.16989 2.86651L2.9547 4.07189C2.55291 4.46879 2.55291 5.11068 2.9449 5.51248L4.05229 6.62966C3.3369 7.68805 2.85181 8.85914 2.60681 10.0694L1.03393 10.0596C0.470434 10.0547 0.014739 10.5104 0.00983903 11.0739L3.91485e-05 12.7889C-0.00486079 13.3475 0.450834 13.8081 1.01433 13.813ZM8.78564 8.75134C10.579 6.97756 13.4651 6.99226 15.2389 8.78564C17.0126 10.579 16.9979 13.4651 15.2046 15.2389C13.4112 17.0126 10.5251 16.9979 8.75134 15.2046C6.97756 13.4112 6.99226 10.5251 8.78564 8.75134Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_1346_1288">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>

      <svg
        v-if="title === 'Account'"
        class="nav-icon"
        width="19"
        height="22"
        viewBox="0 0 19 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 13V21H0C0 18.8783 0.842855 16.8434 2.34315 15.3431C3.84344 13.8429 5.87827 13 8 13ZM8 12C4.685 12 2 9.315 2 6C2 2.685 4.685 0 8 0C11.315 0 14 2.685 14 6C14 9.315 11.315 12 8 12ZM10.595 17.812C10.4682 17.2784 10.4682 16.7226 10.595 16.189L9.603 15.616L10.603 13.884L11.595 14.457C11.9932 14.0799 12.4745 13.8017 13 13.645V12.5H15V13.645C15.532 13.803 16.012 14.085 16.405 14.457L17.397 13.884L18.397 15.616L17.405 16.189C17.5316 16.7222 17.5316 17.2778 17.405 17.811L18.397 18.384L17.397 20.116L16.405 19.543C16.0068 19.9201 15.5255 20.1983 15 20.355V21.5H13V20.355C12.4745 20.1983 11.9932 19.9201 11.595 19.543L10.603 20.116L9.603 18.384L10.595 17.812ZM14 16C13.7348 16 13.4804 16.1054 13.2929 16.2929C13.1054 16.4804 13 16.7348 13 17C13 17.2652 13.1054 17.5196 13.2929 17.7071C13.4804 17.8946 13.7348 18 14 18C14.2652 18 14.5196 17.8946 14.7071 17.7071C14.8946 17.5196 15 17.2652 15 17C15 16.7348 14.8946 16.4804 14.7071 16.2929C14.5196 16.1054 14.2652 16 14 16Z"
          fill="currentColor"
        />
      </svg>
</template>

<script>
export default {
  name: "SidebarIcon",

  props: {
    title: { type: String, default: () => "", required: true },
  },
};
</script>
